export const reportUrlGenerator = (params) => {
  if (!params) return;

  const { reportSource, columns, filters, sortBy } = params;

  let urlString = `/v9/${reportSource}.json?`;

  // check empty cases only the orderAndSortList can be empty.
  if (filters.length === 0) return;

  filters.map((filter, index) => {
    if (!filter["key"].includes("EXTERNAL")) {
      urlString += `${filter["key"]}=${filter["value"]}`;
      urlString += "&";
    }
  });

  if (columns.length === 0) return;

  columns.map((col, index) => {
    if (index == 0) {
      urlString += `output_fields=${col["value"]}`;
    } else {
      urlString += `,${col["value"]}`;
    }
  });

  // urlString += `&SORT_BY=${sortBy["value"]}`;

  return encodeURI(urlString);
};
